<template>
  <!-- eslint-disable -->
  <mi-tab-panel class="bom-results-elements q-px-none q-pb-xs">
    <div v-if="newVersionAvailable && name !== 'incompleteElements'">
      <send-to-search-btn
        problem-type="AMBIGUOUS"
        :bom-validation-results="bomValidationResults"
      >
      </send-to-search-btn>
      <bom-validation-results-version-toggle
        :result-type="name"
        :validation-id="validationId"
      ></bom-validation-results-version-toggle>
    </div>
    <div v-if="newVersionAvailable && name === 'incompleteElements'" class="flex row filter-bar">
      <div class="filter-dropdown-wrapper">
        <bom-validation-results-tar-filtering
          :component-id="componentId"
          :validation-id="validationId"
          :pm-type="pmType"
          :product-model-id="productModelId"
          :filter-results="filterResults"
          @update:kvs-list="updateTarFilterKvsList"
        >
        </bom-validation-results-tar-filtering>
        <send-to-search-btn
          problem-type="INCOMPLETE"
          :bom-validation-results="bomValidationResults"
          :tar-filter-kvs-list="kvsList"
        >
        </send-to-search-btn>
      </div>
      <div class="flex row">
        <bom-validation-version-toggle-incomplete-tab
          :result-type="name"
          :validation-id="validationId"
        ></bom-validation-version-toggle-incomplete-tab>
        <similar-results-toggle
          :result-type="name"
          :validation-id="validationId"
        ></similar-results-toggle>
      </div>
    </div>

    <div
      v-if="(newVersionAvailable && name === 'incompleteElements') && showValidationSimilarResults"
    >
      <div class="flex row justify-between similar-results-header-wrapper">
        <h3 class="similar-results-header">
          Common Expressions
        </h3>
      </div>
      <div class="similar-results-explnations-wrapper">
        <span class="q-mt-nome case-header">Cases 1 - {{ numberOfCases }}</span>
        <div class="similar-results-results-wrapper">
          <div
            v-for="( element, idx ) in duplicatedElements"
            :key="idx"
          >
            <div class="explanation-similar-results-wrapper">
          <span>
            {{ idx + 1 }}
          </span>
              <div v-html="element.formattedExplanation"></div>
            </div>
          </div>
        </div>
      </div>
      <slot name="results" :results="results" :index="0"></slot>
    </div>

    <div v-if="isFilterTarLoading" class="column flex-center full-height">
      <mi-spinner size="24px"></mi-spinner>
    </div>

    <!-- Items list with virtual scroll -->
    <mi-virtual-scroll
      v-if="(items.length && !isFilterTarLoading) && !showValidationSimilarResults"
      :items="items"
      :virtual-scroll-item-size="itemSize"
      :virtual-scroll-slice-size="itemsSliceSize"
    >
      <template #default="{ item, index }">
        <slot :item="item" :index="index"></slot>
      </template>
    </mi-virtual-scroll>

    <!-- No items found caption -->
    <div v-else-if="!isFilterTarLoading && !showValidationSimilarResults" class="column flex-center full-height">
      <mi-icon name="warning-circle" size="2rem"></mi-icon>
      <h6 class="q-mb-none q-mt-md"> No validation results found </h6>
    </div>
  </mi-tab-panel>
</template>

<script>
  import { provide, ref } from 'vue'
  import SimilarResultsToggle from '@/components/validations/bom/validation-results/elements/SimilarResultsToggle.vue'
  import BomValidationResultsVersionToggle from './BomValidationResultsVersionToggle.vue'
  import BomValidationVersionToggleIncompleteTab from './BomValidationVersionToggleIncompleteTab.vue'
  import SendToSearchBtn
    from './send-to-search/BomValidationResultsElementsSendToSearchBtn.vue'
  import BomValidationResultsTarFiltering from '../BomValidationResultsTarFiltering.vue'
  import MiSpinner from '../../../../../packages/@mi-library/MiSpinner/MiSpinner.vue'

  export default {
    name: 'BomValidationResultsElements',
    components: {
      SendToSearchBtn,
      MiSpinner,
      BomValidationResultsTarFiltering,
      BomValidationVersionToggleIncompleteTab,
      BomValidationResultsVersionToggle,
      SimilarResultsToggle
    },
    props: {
      activeTab: {
        type: String,
        required: false,
        default: ''
      },
      itemSize: {
        type: [Number, String],
        required: false,
        default: 48
      },
      itemsSliceSize: {
        type: [Number, String],
        required: false,
        default: 30
      },
      name: {
        type: String,
        required: false,
        default: ''
      },
      validationId: {
        type: String,
        required: false,
        default: ''
      },
      productModelId: {
        type: String,
        required: false,
        default: ''
      },
      pmType: {
        type: String,
        required: false,
        default: ''
      },
      componentId: {
        type: String,
        required: false,
        default: () => {}
      },
      bomValidationResults: {
        type: Object,
        required: false,
        default: () => {}
      },
      items: {
        type: Array,
        required: false,
        default: () => []
      },
      filterResults: {
        type: Function,
        required: false,
        default: () => {}
      },
      newVersionAvailable: {
        type: Boolean,
        required: false,
        default: false
      },
      duplicatedElements: {
        type: Array,
        required: false,
        default: () => []
      },
      showValidationSimilarResults: {
        type: Boolean,
        required: false,
        default: false
      },
      numberOfCases: {
        type: Number,
        required: false,
        default: 0

      },
      results: {
        type: Array,
        required: false,
        default: () => []
      }
    },
    setup() {
      const isFilterTarLoading = ref(false)
      provide('isFilterTarLoading', isFilterTarLoading)
      const kvsList = ref([])

      const updateTarFilterKvsList = value => {
        kvsList.value = value
      }

      return {
        isFilterTarLoading,
        kvsList,
        updateTarFilterKvsList
      }
    }
  }
</script>

<style lang="scss" scoped>
  .bom-results-elements ::v-deep(.q-virtual-scroll__content) > .mi-list-item {
    border: 2px solid $mi-anthracite-400;
  }

  .filter-bar {
    justify-content: space-between;
  }

  .bom-results-elements ::v-deep(.q-virtual-scroll) {
    height: calc(100vh - 265px);
  }

  // stylelint-disable selector-max-compound-selectors
  .bom-results-elements ::v-deep(.q-virtual-scroll__content) > .mi-list-item + .mi-list-item {
    border-top: 0;
  }

  .similar-results-wrapper {
    padding: 20px;
  }

  .similar-results-header {
    margin: 5px;
  }

  .filter-dropdown-wrapper {
    display: flex;
    align-items: center;
  }

  .similar-results-header-wrapper {
    align-items: center;
  }

  .case-header {
    display: flex;
    justify-content: flex-end;
    font-size: 14px;
    color: #545454;
    font-weight: 500;
  }

  .explanation-similar-results-wrapper {
    display: flex;
    flex-direction: row;
    color: #5b7085;
    font-weight: 400;
    font-size: 14px;
    line-height: 1.3rem;
    gap: 8px;
  }

  .similar-results-explnations-wrapper {
    padding: 20px;
  }

  .similar-results-results-wrapper {
    padding: 8px;
    background: #eaedf366;
  }
</style>
